<script setup lang="ts">
import EpIcon from '~/components/icon/EpIcon.vue'

interface IProps {
  value?: unknown
  iconName: string
  iconSize: number | string
  type?: 'glass' | 'line'
  disabled?: boolean
}

withDefaults(defineProps<IProps>(), {
  type: 'glass'
})

const emits = defineEmits([ 'click' ])
</script>

<template>
  <button
    @click.stop="emits('click', value)"
    class="icon-button"
    :class="type"
    :disabled="disabled"
  >
    <EpIcon
      :name="iconName"
      :size="iconSize"
    />
  </button>
</template>

<style scoped lang="scss">
.icon-button {
  @apply flex items-center justify-center p-2;
  transition: all 0.3s ease;

  &.line {
    @apply border border-primary text-primary;

    &:hover {
      @apply bg-primary/10;
    }

    &:active {
      @apply bg-primary/20;
    }

    &:disabled {
      @apply bg-default/10 text-default/40;
    }
  }
}
</style>